import './App.css';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import LandingPageContainer from './components/LandingPage/landingPageContainer';
// import HowItWorks from './components/LandingPage/HowItWorks/HowItWorks';

function App() {
	return (
		<div className="App">
			{/* Landing Page Components */}
			<Router>
				{/* Hero section */}
				<Route exact path="/">
					<LandingPageContainer />
				</Route>
				<Route exact path="/Thumbs">
					<LandingPageContainer />
				</Route>
				{/* How it works section */}
				{/* <Route path="/HowItWorks" component={HowItWorks} /> */}
			</Router>
		</div>
	);
}

export default App;
